var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20.25px",
    height: "15.75px",
    viewBox: "0 0 20.25 15.75",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "car_transavia") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ShoppingCart",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "car_transavia",
    transform: "translate(-1.875000, -3.750000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "box"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21,7.5 L19.425,7.5 L18.6,5.175 C18.225,4.35 17.4,3.75 16.425,3.75 L12,3.75 L7.575,3.75 C6.6,3.75 5.775,4.35 5.475,5.175 L4.575,7.5 L3,7.5 C2.4,7.5 1.875,8.025 1.875,8.625 L1.875,8.625 C1.875,9.225 2.4,9.75 3,9.75 L3.75,9.75 L3.15,10.35 C2.55,10.95 2.25,11.7 2.25,12.525 L2.25,19.5 L5.25,19.5 L5.25,17.25 L18.75,17.25 L18.75,19.5 L21.75,19.5 L21.75,12.525 C21.75,11.7 21.45,10.95 20.85,10.425 L20.25,9.75 L21,9.75 C21.6,9.75 22.125,9.225 22.125,8.625 L22.125,8.625 C22.125,8.025 21.6,7.5 21,7.5 Z M8.25,15 L4.5,15 L4.5,12.75 L8.25,13.5 L8.25,15 Z M6.15,9.75 L7.575,6 L16.425,6 L17.85,9.75 L6.15,9.75 Z M19.5,15 L15.75,15 L15.75,13.5 L19.5,12.75 L19.5,15 Z",
    id: "Shape",
    fill: "#2800A0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCar);
export default __webpack_public_path__ + "static/media/icon-car.4d60b1d082ab2097fab6107bc16ea92a.svg";
export { ForwardRef as ReactComponent };